module.exports = "<h5 class=text-left><i class=\"fa fa-lg fa-{2}\"></i>&nbsp;<strong>{0}</strong>&nbsp;{1}</h5> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-utils-notify/services/notify/toast-templates/iconized-and-titled.html
// module id = 440
// module chunks = 0